import { ApolloClient, ApolloProvider, ApolloLink, HttpLink, InMemoryCache, createHttpLink, split } from '@apollo/client';

import { getMainDefinition } from '@apollo/client/utilities';
import { setContext } from '@apollo/link-context';
import { onError } from '@apollo/client/link/error';
import { WebSocketLink } from '@apollo/client/link/ws';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import auth from './utils/auth';

// Define the error link with the onError callback
const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        console.log('inside the graphql error ', graphQLErrors);

        // Check for specific error codes, such as 401 (unauthorized)
        if (
            graphQLErrors[0]?.message === 'Please Login First' ||
            graphQLErrors[0]?.message === 'Please login first' ||
            graphQLErrors[0]?.message === 'Cannot return null for non-nullable field Query.generateKitchenReport.'
        ) {
            // Clear the cache
            client.clearStore();
            localStorage.clear();
            // Redirect the user to the login page
            window.location.href = '/login';
        }
        for (const error of graphQLErrors) {
            if (error.message === 'Unauthorized access. Please Login First' || error.message === 'Login First') {
                console.log('sub inside the graphql error ', graphQLErrors);
                // Clear the cache
                client.clearStore();
                localStorage.clear();
                // Redirect the user to the login page
                // Replace the URL with your desired login page
                window.location.href = '/login';
            }
        }
    }

    if (networkError) {
        // Handle network errors here if needed
        console.log('Network error:', networkError);
    }
});

// Create an httpLink
const httpLink = createHttpLink({
    uri: `${process.env.REACT_APP_GRAPHQL_URL}` // Replace with your GraphQL endpoint URL
});

const authLink = setContext((_, { headers }) => {
    const token = auth.getToken() || null;
    return token
        ? {
              headers: {
                  ...headers,
                  authorization: token ? `Bearer ${token.accessToken}` : ''
              }
          }
        : null;
});

const omitTypename = (key, value) => (key === '__typename' ? undefined : value);

export const omitTypenameLink = new ApolloLink((operation, forward) => {
    if (operation.variables) {
        operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
    }
    return forward ? forward(operation) : null;
});

// WebSocket Link for Subscriptions
const wsLink = new WebSocketLink(
    new SubscriptionClient(process.env.REACT_APP_GRAPHQL_WS_URL, {
        reconnect: true,
        connectionParams: {
            authToken: `Bearer ${auth?.getToken()?.accessToken || ''}`
        },
        onError: (err) => console.error('WebSocket Error:', err)
    })
);

const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink, // WebSocket link for subscriptions
    // authLink.concat(httpLink) // HTTP link for queries and mutations
    authLink.concat(ApolloLink.from([omitTypenameLink, errorLink, httpLink]))
);

// Create an Apollo Client instance
const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: splitLink
});

export default client;
